// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"vj_a zu_i zu_q zu_j"};